import { getField } from 'vuex-map-fields'
import buildInitialStatus from '@/store/helpers/buildInitialState'

const defaultMessage = 'Processing. Please wait...'

const progressModal = {
  namespaced: true,
  state: buildInitialStatus({
    showModal: false,
    message: defaultMessage,
    // Tracks how many async operations are currently showing the modal.
    // Multiple store actions can call showProgressModal concurrently; the modal
    // stays visible until every caller has called hideProgressModal (count reaches 0).
    pendingCount: 0
  }),
  getters: {
    getField
  },
  actions: {
    showProgressModal: ({ commit }, { message = defaultMessage }) => {
      return commit('showProgressModal', { message })
    },
    hideProgressModal: ({ commit }) => {
      commit('hideProgressModal')
    }
  },
  mutations: {
    showProgressModal (state, { message }) {
      // Increment so we know one more operation is in progress
      state.pendingCount++
      state.showModal = true
      state.message = message
    },
    hideProgressModal (state) {
      // Decrement; Math.max guards against going negative if hide is called without a matching show
      state.pendingCount = Math.max(0, state.pendingCount - 1)
      // Only hide the modal once all pending operations have finished
      if (state.pendingCount === 0) {
        state.showModal = false
        state.message = defaultMessage
      }
    }
  }
}

export default progressModal
